import type { ChatGroupMember } from '@/contexts/chat/scripts/hooks/useChatGroup/types';
import { ChatMessagePayloadType } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import SearchMemberSelect from '@/components/search-member-select';
import styles from './index.module.scss';

interface GroupCreateCallProps {
  open: boolean;
  normalMemberList: ChatGroupMember[];
  onCancel: () => void;
  onCall: (payload: ChatMessagePayloadType, selectUsers: ChatGroupMember[]) => void;
}
const GroupCreateCall = ({
  open,
  normalMemberList,
  onCancel,
  onCall,
}: GroupCreateCallProps) => {
  const [selectUsers, setSelectUsers] = useState<ChatGroupMember[]>([]);

  const handleSelectAll = () => {
    const normalMemberList_ = normalMemberList; // normalMemberList.filter((_, index) => index !== 1);
    if (selectUsers.length === normalMemberList_?.length) {
      setSelectUsers([]);
    } else {
      setSelectUsers(normalMemberList_ ?? []);
    }
  };

  useEffect(() => {
    if (!open) {
      setSelectUsers([]);
    }
  }, [open]);

  return (
    <Modal
      width={666}
      title="Select members"
      open={open}
      onCancel={onCancel}
      maskClosable={false}
      className={styles.groupMediaCreateCallModal}
      footer={null}
    >
      <SearchMemberSelect
        data={normalMemberList}
        value={selectUsers}
        onSelect={setSelectUsers}
      ></SearchMemberSelect>
      <div className={styles.footer}>
        <div className={styles.selectAll} onClick={handleSelectAll}>
          <Checkbox
            className={styles.checkbox}
            checked={selectUsers.length === normalMemberList?.length}
          >
            Select all
          </Checkbox>
        </div>
        <Space>
          <Button
            onClick={() => onCall(ChatMessagePayloadType.MEDIA_AUDIO_CALL, selectUsers)}
          >
            voice call Group
          </Button>
          <Button
            onClick={() => onCall(ChatMessagePayloadType.MEDIA_VIDEO_CALL, selectUsers)}
          >
            video call Group
          </Button>
        </Space>
      </div>
    </Modal>
  );
};

export default GroupCreateCall;
